<script>

    export let result;

</script>

<h1>Ergebnis</h1>

{#if result.done == true}
    <p>Super Ergebnis! Du hast {result.percentage} % der Fragen richtig beantwortet.</p>
{:else}
    <p>Leider nicht alle Fragen richtig. Du hast {result.percentage} % der Fragen richtig beantwortet.</p>
    <p>Dran bleiben!</p>
{/if}